module.exports = __webpack_public_path__ + "img/gallery-7.74aa1af4.jpeg";